import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["connector", { connectorIsSelected: _ctx.connectorIsSelected, [`color-${ _ctx.connector.colorId }`]: true }]),
    onClick: $event => (_ctx.selectConnector(_ctx.connector.id)),
    style: _normalizeStyle(`grid-area: ${_ctx.connector.block.y+1}/${_ctx.connector.block.x+1}/${_ctx.blockYEnd(_ctx.connector.block)+1}/${_ctx.blockXEnd(_ctx.connector.block)+1}`)
  }, null, 14 /* CLASS, STYLE, PROPS */, ["onClick"]))
}